import { InjectableConfig } from '../enums';
import { useWindowedObservable } from './use-windowed-observable';
export var useAxios = function() {
    return useWindowedObservable(InjectableConfig.Axios);
};
export var useFboAxios = function() {
    return useWindowedObservable(InjectableConfig.FboAxios);
};
export var useEnvironment = function() {
    return useWindowedObservable(InjectableConfig.Environment);
};
export var useRollbarInstance = function() {
    return useWindowedObservable(InjectableConfig.Rollbar);
};
